export default __webpack_public_path__ + "static/media/chevron_droite.aec7aa9a.svg";